import { PolicyType } from '../graphql'
import Price from './Price'

export enum PatronQuestionType {
  PATRON_QUESTION_TYPE_PAST_ATTENDANCE = 'PATRON_QUESTION_TYPE_PAST_ATTENDANCE',
  PATRON_QUESTION_TYPE_CHANNEL = 'PATRON_QUESTION_TYPE_CHANNEL',
  PATRON_QUESTION_TYPE_NONE = 'PATRON_QUESTION_TYPE_NONE',
}

export enum PatronageAnswer {
  PATRONAGE_ANSWER_EVERSPORTS = 'PATRONAGE_ANSWER_EVERSPORTS',
  PATRONAGE_ANSWER_VENUE_CHANNELS = 'PATRONAGE_ANSWER_VENUE_CHANNELS',
  PATRONAGE_ANSWER_VENUE_CUSTOMER = 'PATRONAGE_ANSWER_VENUE_CUSTOMER',
  PATRONAGE_ANSWER_VENUE_MEMBERS = 'PATRONAGE_ANSWER_VENUE_MEMBERS',
}

export enum RequiredInformationType {
  REQUIRED_INFORMATION_TYPE_ADDRESS = 'REQUIRED_INFORMATION_TYPE_ADDRESS',
  REQUIRED_INFORMATION_TYPE_BIRTHDAY = 'REQUIRED_INFORMATION_TYPE_BIRTHDAY',
  REQUIRED_INFORMATION_TYPE_PHONE_NUMBER = 'REQUIRED_INFORMATION_TYPE_PHONE_NUMBER',
  REQUIRED_INFORMATION_TYPE_FISCAL_CODE = 'REQUIRED_INFORMATION_TYPE_FISCAL_CODE',
}

export interface Address {
  street: string
  zip: string
  city: string
  country: string
  detail: string
}

export interface Birthday {
  birthday: string
}

export interface PhoneNumber {
  phoneNumber: string
}

export interface FiscalCode {
  fiscalCode: string
}

export interface RequiredInformationInput {
  address?: Address | null
  phoneNumber?: string | null
  birthday?: string | null
  fiscalCode?: string | null
}

export interface AddOn {
  id: string
  description?: string
  mandatory?: boolean
  fields?: Array<AddOnField>
}

interface AddOnFieldBase {
  id: string
  description: string
}

interface SelectAddOnFieldOption {
  id: string
  description: string
  price: Price | null
}

interface TextAddOnField extends AddOnFieldBase {
  __typename: 'TextAddOnField'
  price: Price | null
}

interface NumberAddOnField extends AddOnFieldBase {
  __typename: 'NumberAddOnField'
  price: Price | null
}

export enum SelectAddOnFieldSelectionType {
  SELECTION_TYPE_MULTI = 'SELECTION_TYPE_MULTI',
  SELECTION_TYPE_SINGLE = 'SELECTION_TYPE_SINGLE',
}

export interface SelectAddOnField extends AddOnFieldBase {
  __typename: 'SelectAddOnField'
  selectionType: SelectAddOnFieldSelectionType
  options: Array<SelectAddOnFieldOption>
}

export type AddOnField = TextAddOnField | NumberAddOnField | SelectAddOnField

export interface AddOnFieldInput {
  id: string
  numberValue?: number | null
  textValue?: string | null
  singleSelectionValue?: string | null
  multiSelectionValue?: Array<string> | null
}

export interface AddOnInput {
  id: string
  fields: Array<AddOnFieldInput>
}

interface PolicyBase {
  id: string
  url: string
  mandatory: boolean
}

interface PrivacyPolicy extends PolicyBase {
  type: PolicyType.POLICY_TYPE_PRIVACY
}

interface TermsOfServicePolicy extends PolicyBase {
  type: PolicyType.POLICY_TYPE_TERMS_OF_SERVICE
}

export type Policy = PrivacyPolicy | TermsOfServicePolicy

export interface AddOnsInitialValues {
  [key: string]: Array<string> | [] | string
}

export interface PoliciesInitialValues {
  policies: Array<string>
}

export interface PatronQuestionInitialValues {
  isPatron: string
}

export interface MultiAnswerPatronQuestionInitialValues {
  patronageAnswer?: PatronageAnswer
}

export type RequiredInformationInitialValues = Partial<Address & Birthday & PhoneNumber & FiscalCode>
